export const START_FETCHING = 'START_FETCHING'
export const STOP_FETCHING = 'STOP_FETCHING'

export const startFetching = (text) => {
    return {
        type: START_FETCHING,
        text,
    }
}

export const stopFetching = (text) => {
    return {
        type: STOP_FETCHING,
        text,
    }
}



// WEBPACK FOOTER //
// ./state/actions/CMT/Fetching.js